<div class="modal-header">
  <h4 style="padding-right: 4px;" class="modal-title">Endpoint</h4>
  <button style="margin-right:4px;" type="button" class="close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <i style="font-size:16px;" class="fas fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <div class="modal-body-inner">
    <form (ngSubmit)="createEditEndpoint()" [formGroup]="endpointForm">
      <div class="form-group">
        <label class="d-block">
          <label labelfor="azureAccountId" class="input-label">* Pharmacy</label>

          <div>
            <ejs-dropdownlist #pharmacyDropdown id="pharmacyDropdown" (change)="pharmacyChanged()" [dataSource]='data'
              [fields]='fields' [readonly]="isDropdownReadOnly" (filtering)='onFiltering($event)'
              [filterBarPlaceholder]="filterPlaceholder" [popupHeight]='280' [allowFiltering]='true'
              [placeholder]='watermark'>
              <ng-template #itemTemplate="" let-data="">
                <!--set the value to itemTemplate property-->
                <div>
                  <div class='pharmacy-name'>
                    {{data.Pharmacy}}
                  </div>
                  <div class='npi-no'>
                    <span class='font-weight-bold'>Address:</span> {{data.StreetAddress}}
                    {{data.City}} {{data.ZIPCode}}
                    {{data.State}}
                  </div>
                  <div class='npi-no'>
                    <span class='font-weight-bold'>NPI:</span> {{data.NpiNo}}
                  </div>


                </div>
              </ng-template>

            </ejs-dropdownlist>
          </div>
          <!-- <select id="pharmacy" [attr.disabled]="this.azureEndpointId && this.azureEndpointId > 0 ? '' : null"
            (change)="onPharmacyChanged()" [ngModelOptions]="{standalone: true}" placeholder="Select a pharmacy"
            type="number" [(ngModel)]="selectedPharmacy">
            <option *ngFor="let pharmacy of pharmacies" [ngValue]="pharmacy">{{pharmacy.pharmacy}}</option>
          </select> -->
          <label [ngClass]="isPharmacySelected ? '' : 'active'" class="error">Pharmacy is a
            required field.</label>
        </label>
      </div>

      <address *ngIf="selectedPharmacy">
        {{selectedPharmacy?.StreetAddress}} <br>
        {{selectedPharmacy?.City}} - {{selectedPharmacy?.ZIPCode}} <br>
        {{selectedPharmacy?.State}}
      </address>

      <div class="form-group">
        <label class="d-block">
          <label labelfor="azureAccountId" class="input-label">* Azure Account</label>
          <select [attr.disabled]="this.azureEndpointId && this.azureEndpointId > 0 ? '' : null"
            (change)="onAccountChanged()" [ngModelOptions]="{standalone: true}" placeholder="Select an account"
            type="number" [(ngModel)]="selectedAzureAccount">
            <option *ngFor="let account of azureAccounts" [ngValue]="account">{{account.AccountName}}</option>
          </select>
          <label [ngClass]="isAccountSelected ? '' : 'active'" class="error">Account is a
            required field.</label>
        </label>
      </div>
      <div class="form-group">
        <label class="d-block">
          <label labelfor="azureAccountId" class="input-label">* Azure Namespace</label>
          <select [attr.disabled]="this.azureEndpointId && this.azureEndpointId > 0 ? '' : null"
            (change)="onNamespaceChanged()" [ngModelOptions]="{standalone: true}" placeholder="Select a namespace"
            type="number" [(ngModel)]="selectedAzureNamespace">
            <option *ngFor="let nmspace of azureNamespaces" [ngValue]="nmspace">{{nmspace.Namespace}}</option>
          </select>
          <label *ngIf="endpointsCountForSelectedNamespace && endpointsCountForSelectedNamespace > 0"
            style="font-size: 12px;">{{textForEndpointsCount}}</label>
          <label [ngClass]="isNamespaceSelected ? '' : 'active'" class="error">Namespace is a
            required field.</label>
        </label>
      </div>


      <div class="form-group">
        <label class="d-block">
          <label labelfor="endpoint" class="input-label">* Endpoint</label>
          <input type="text" id="endpoint" placeholder="Select pharmacy and endpoint will be displayed"
            formControlName="endpoint" />
          <label [ngClass]="isEndpointEntered ? '' : 'active'" class="error">Endpoint is a required
            field.</label>
          <label style="overflow-wrap:anywhere" class="text-muted text-monospace">{{fullUrl}}</label>
        </label>
      </div>

      <div *ngIf="this.azureEndpointId && this.azureEndpointId > 0" class="form-group">
        <label class="d-block">

          <label style="color:#000" class="container-checkbox">
            Active
            <input type="checkbox" formControlName="checkActive" />
            <span class="checkmark"></span>
          </label>
        </label>
      </div>


      <div class="form-group">
        <button type="submit" class="btn btn-success btn-login" type="submit">
          <span [hidden]="isLoading">Save</span>
          <span [hidden]="!isLoading">
            <i class="fas fa-spinner fa-pulse"></i>
          </span>
        </button>
        <div [hidden]="!isErrorVisible" class="alert alert-danger mt-2" role="alert">
          {{error}}
        </div>

      </div>
    </form>
  </div>
</div>
